module.exports = __webpack_public_path__ + "4950a7205f0b5cefe41fc03ac346e236.woff2";